import axios from "axios";

export default {
  state: {
    selectedItem: null,
    treeData: {},
    settingTest: null,
    htmlEditorActive: false,
  },

  getters: {
    getSelectedItem(state) {
      return state.selectedItem;
    },
  },
  mutations: {
    setHtmlEditorActive(state, value) {
      state.htmlEditorActive = value;
    },
    setSettingTest(state, value) {
      state.settingTest = value;
    },
    setTreeData(state, value) {
      state.treeData = value;
    },
    setChildrenTreeData(state, value) {
      state.treeData.children = value;
    },
    setSelectedItem(state, value) {
      state.selectedItem = value;
    },
    updateSelectedItem(state, value) {
      state.selectedItem.children = value;
    },
    updateSelectedItemLable(state, value) {
      state.selectedItem.lable = value;
    },
    updateSelectedItemBody(state, value) {
      state.selectedItem.body = value;
    },
    updateSelectedItemPath(state, value) {
      state.selectedItem.path = value;
    },
    updateVideoTree(state, value) {
      state.treeData.videos = value;
    },
    updateWebinarTree(state, value) {
      state.treeData.webinars = value;
    },
  },

  actions: {
    async updateFile({ commit }, { path, data }) {
      let response = {};
      await axios
        .post(path, data)
        .then(res => {
          if (res.data.status) {
            commit("setChildrenTreeData", res.data.menu);
            data.status === "update"
              ? commit("updateSelectedItemBody", data.body)
              : null;
            commit("updateSelectedItem", res.data.subMenu);
            response.status = true;
          } else {
            response.status = false;
          }
          response.message = res.data.message;
        })
        .catch(error => {
          console.error(error);
        });
      return response;
    },
    async saveFile({ commit }, { path, data }) {
      let response = {};
      await axios
        .post(path, data)
        .then(res => {
          if (res.data.status) {
            commit("setChildrenTreeData", res.data.menu);
            commit("updateSelectedItem", res.data.subMenu);
            response.status = true;
          } else {
            response.status = false;
          }
          response.message = res.data.message;
        })
        .catch(error => {
          console.error(error);
        });
      return response;
    },
    async editItemDiscipline({ commit }, data) {
      let response = {};
      await axios
        .post(`api/disciplines/${data.disciplineId}/materials/update`, data)
        .then(res => {
          if (res.data.status) {
            if (res.data.type === "file") {
              commit("updateSelectedItemBody", res.data.new_boby);
            }
            commit("setChildrenTreeData", res.data.menu);
            commit("updateSelectedItemPath", res.data.new_path);
            commit("updateSelectedItemLable", res.data.new_lable);
            response.status = true;
          } else {
            response.status = false;
          }
          response.message = res.data.message;
        })
        .catch(error => {
          console.error(error);
        });
      return response;
    },
    async createItemDiscipline({ commit }, data) {
      let response = {};
      await axios
        .post(`api/disciplines/${data.disciplineId}/materials`, data)
        .then(res => {
          if (res.data.status) {
            commit("setChildrenTreeData", res.data.menu);
            commit("updateSelectedItem", res.data.subMenu);
            response.status = true;
          } else {
            response.status = false;
          }
          response.message = res.data.message;
        })
        .catch(error => {
          console.error(error);
        });
      return response;
    },
    async deliteItemDiscipline({ commit }, data) {
      let response = {};
      await axios
        .post(`api/disciplines/${data.disciplineId}/materials/delete`, data)
        .then(res => {
          if (res.data.status) {
            commit("setChildrenTreeData", res.data.menu);
            commit("setSelectedItem", null);
            response.status = true;
          } else {
            response.status = false;
          }
          response.message = res.data.message;
        })
        .catch(error => {
          console.error(error);
        });
      return response;
    },
    async fetchDataDiscipline({ commit }, path = "") {
      axios.get(path).then(res => {
        let dataObj = {
          id: 0,
          execution: "material-tree",
          level: 0,
          lable: res.data.discipline_name,
          children: res.data.menu,
          path: res.data.path,
          type: "directory",
          videos: res.data.videos,
          webinars: res.data.webinars_arch,
          tests: res.data.tests,
        };
        commit("setTreeData", dataObj);
      });
    },
  },
};
